<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <h4 class="title is-4">{{createOrUpdate}}</h4>
    <div class="columns">
      <div class="column is-3">
        <label class="label is-small">Blog image (single)</label>
        <div class="control">
          <span v-if="blogImagePreview">
            <img :src="blogImagePreview" width="200" height="200" border="1" />
          </span>
          <span v-else>
            <span v-if="isLoadingImage">
              <img src="../../assets/loading.gif" width="200" height="200" border="1" />
            </span>
            <span v-else>
              <img src="../../assets/newspaper.png" width="200" height="200" border="1" />
            </span>
          </span>
          <br />
          <input accept="image/*" type="file" @change="fileChange($event.target.files)" ref="blogImageInput" />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Title</label>
          <div class="control">
            <input type="text" v-model="newsfeed.name" class="input is-small" v-validate="'required'" name="Name" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Name') }}</span>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Description</label>
          <div class="control">
            <textarea type="text" v-model="newsfeed.desc" class="input is-small" v-validate="'required'" name="Desc" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Desc') }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Date</label>
          <div class="control">
            <input type="date" v-model="newsfeed.date" class="input is-small" v-validate="'required'" name="Date" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Date') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="clear:both"></div>
    <button :class="buttonSave" @click="saveBlog">Save</button>
    &nbsp;
        <router-link :to="{name: 'List Of Newsfeed'}" class="button is-small">Go back to list</router-link>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import moment from 'moment'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    createOrUpdate: 'Create',
    blogImagePreview: null,
    isLoadingImage: false,
    newsfeedFormData: new FormData(),
    newsfeed: {
      newsfeedId: 0
    },
    buttonSave: appButton.isLoadingSuccess(false),
    isLoading: false
  }),
  created() {
    const newsfeedId = this.$route.params.newsfeedId
    if (newsfeedId) {
      this.createOrUpdate = '...'
      this.getNewsfeedById(newsfeedId)
    }
  },
  methods: {
    default() {
      this.newsfeedFormData = new FormData()
      this.buttonSave = appButton.isLoadingSuccess(false)
    },
    fileChange(file) {
      for (let i = 0; i < file.length; i++) {
        this.newsfeedFormData.append('blogImage', file[i], file[i].name)
      }

      this.blogImagePreview = URL.createObjectURL(file[0])
    },
    getNewsfeedById(id) {
      this.isLoading = true
      axios
        .get(`api/newsfeeds/${id}`)
        .then(response => {
          response.data.date = moment(response.data.date).format('YYYY-MM-DD')
          this.newsfeed = response.data
          this.getNewsfeedImageById(response.data.newsfeedId)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.createOrUpdate = 'Edit'
          this.isLoading = false
        })
    },
    getNewsfeedImageById(id) {
      if (id) {
        this.isLoadingImage = true
        axios
          .get(`api/newsfeeds/blog-image-byte/${id}`)
          .then(response => {
            this.blogImagePreview = `data:image/png;base64, ${response.data}`
          })
          .catch(error => {
            console.log(error)
          })
          .then(() => {
            this.isLoadingImage = false
          })
      }
    },
    saveBlog() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          this.newsfeedFormData.append(
            'newsfeedDetail',
            JSON.stringify(this.newsfeed)
          )

          if (this.newsfeed.newsfeedId == 0) {
            // Create
            axios
              .post(`api/newsfeeds/`, this.newsfeedFormData)
              .then(response => {
                appToast.success(response.data)
                this.$router.push({ name: 'List Of Newsfeed' })
              })
              .catch(error => {
                appToast.danger(error.response.data)
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
          } else {
            // Update
            axios
              .put(
                `api/newsfeeds/${this.newsfeed.newsfeedId}`,
                this.newsfeedFormData
              )
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                appToast.danger(error.response.data)
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
              .then(() => {
                this.default()
                this.getNewsfeedById(this.$route.params.newsfeedId)
              })
          }
        }
      })
    }
  }
}
</script>
